var _filter, _g, _g2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 49,
    viewBox: "0 0 49 49",
    width: 49,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 49,
    width: 49,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_6703_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6703_13",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    fill: "#fff",
    r: 20.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6a7988"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.31 17.3287v18.0961c0 .2301-.1187.4219-.356.5369-.0791.0383-.1581.0383-.2372.0383-.1581 0-.2771-.0383-.3957-.1533l-1.3843-1.189-1.3846 1.189c-.2373.1918-.5538.1918-.7911 0l-1.3845-1.189-1.3846 1.189c-.2373.1918-.5538.1918-.7911 0l-1.3843-1.189-1.3846 1.189c-.2373.1918-.5537.1918-.791 0l-1.3843-1.189-1.3846 1.189c-.2373.1918-.5538.1918-.7911 0l-1.3846-1.189-1.3845 1.189c-.1581.1533-.4352.1918-.633.0768-.237-.0768-.3557-.2686-.3557-.4987v-23.8496c0-.3068.2771-.5752.5933-.5752h11.8667.1186c.0395 0 .0395 0 .0792.0383h.0395c.0394 0 .0394.0382.0791.0382h.0395c.0395.0383.0792.0383.0792.0768l2.9667 2.8767c1.7007 1.6492 2.4524 2.3781 2.8086 2.7617.1581.0768.277.2301.3164.4219-.0002.0383 0 .0768 0 .1151zm-5.9334-4.3726v3.7973h3.9161c-1.1075-1.074-2.8086-2.7234-3.9161-3.7973zm4.7469 21.2029v-16.2549h-5.3401c-.3165 0-.5933-.2687-.5933-.5753v-5.1782h-10.68v22.0084l.7911-.6903c.1186-.1151.2372-.1533.3956-.1533.1581 0 .277.0382.3957.1533l1.3846 1.189 1.3846-1.189c.2373-.1918.5537-.1918.791 0l1.3846 1.189 1.3846-1.189c.2373-.1918.5538-.1918.791 0l1.3846 1.189 1.3846-1.189c.2373-.1918.5538-.1918.7911 0l1.3846 1.189 1.3845-1.189c.2373-.1918.5538-.1918.7911 0zm-2.8419-5.9124h-10.8674c-.3165 0-.5932.2686-.5932.5752 0 .3069.277.5752.5932.5752h10.8674c.3165 0 .5932-.2686.5932-.5752s-.2767-.5752-.5932-.5752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.414 25h10.8674c.3165 0 .5933.2686.5933.5752s-.2768.5753-.5933.5753h-10.8674c-.3162 0-.5932-.2684-.5932-.5753 0-.3066.2768-.5752.5932-.5752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.414 21.8495h10.8674c.3165 0 .5933.2686.5933.5753 0 .3066-.2768.5752-.5933.5752h-10.8674c-.3162 0-.5932-.2684-.5932-.5752 0-.3067.2768-.5753.5932-.5753z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.31 17.3287v18.0961c0 .2301-.1187.4219-.356.5369-.0791.0383-.1581.0383-.2372.0383-.1581 0-.2771-.0383-.3957-.1533l-1.3843-1.189-1.3846 1.189c-.2373.1918-.5538.1918-.7911 0l-1.3845-1.189-1.3846 1.189c-.2373.1918-.5538.1918-.7911 0l-1.3843-1.189-1.3846 1.189c-.2373.1918-.5537.1918-.791 0l-1.3843-1.189-1.3846 1.189c-.2373.1918-.5538.1918-.7911 0l-1.3846-1.189-1.3845 1.189c-.1581.1533-.4352.1918-.633.0768-.237-.0768-.3557-.2686-.3557-.4987v-23.8496c0-.3068.2771-.5752.5933-.5752h11.8667.1186c.0395 0 .0395 0 .0792.0383h.0395c.0394 0 .0394.0382.0791.0382h.0395c.0395.0383.0792.0383.0792.0768l2.9667 2.8767c1.7007 1.6492 2.4524 2.3781 2.8086 2.7617.1581.0768.277.2301.3164.4219-.0002.0383 0 .0768 0 .1151zm-5.9334-4.3726v3.7973h3.9161c-1.1075-1.074-2.8086-2.7234-3.9161-3.7973zm4.7469 21.2029v-16.2549h-5.3401c-.3165 0-.5933-.2687-.5933-.5753v-5.1782h-10.68v22.0084l.7911-.6903c.1186-.1151.2372-.1533.3956-.1533.1581 0 .277.0382.3957.1533l1.3846 1.189 1.3846-1.189c.2373-.1918.5537-.1918.791 0l1.3846 1.189 1.3846-1.189c.2373-.1918.5538-.1918.791 0l1.3846 1.189 1.3846-1.189c.2373-.1918.5538-.1918.7911 0l1.3846 1.189 1.3845-1.189c.2373-.1918.5538-.1918.7911 0zm-2.8419-5.9124h-10.8674c-.3165 0-.5932.2686-.5932.5752 0 .3069.277.5752.5932.5752h10.8674c.3165 0 .5932-.2686.5932-.5752s-.2767-.5752-.5932-.5752z",
    stroke: "#6a7988",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.414 25h10.8674c.3165 0 .5933.2686.5933.5752s-.2768.5753-.5933.5753h-10.8674c-.3162 0-.5932-.2684-.5932-.5753 0-.3066.2768-.5752.5932-.5752z",
    stroke: "#6a7988",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.414 21.8495h10.8674c.3165 0 .5933.2686.5933.5753 0 .3066-.2768.5752-.5933.5752h-10.8674c-.3162 0-.5932-.2684-.5932-.5752 0-.3067.2768-.5753.5932-.5753z",
    stroke: "#6a7988",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.a597c75ec08f19208815db1598de35b6.svg";
export { ForwardRef as ReactComponent };